/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connectivity_History_DriftInputs */



/**
* | output |
* | --- |
* | "Deviation" |
*
* @param {Connectivity_History_DriftInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const connectivity_history_drift = /** @type {((inputs?: Connectivity_History_DriftInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connectivity_History_DriftInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Deviation")
	return /** @type {LocalizedString} */ ("Écart")
});